export default __webpack_public_path__ + "static/media/stop.29ff75ad.svg";